import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Go to Home Page ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_n_result = _resolveComponent("n-result")!

  return (_openBlock(), _createBlock(_component_n_result, {
    status: "404",
    title: "404 Not Found",
    description: "You know life is always ridiculous.",
    class: "pt-32"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            type: "info",
            onClick: _ctx.goHome
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}